"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[143],{

/***/ 143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ videoPlayer)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
// components/videoPlayer.js


// node: '[data-video-player]'

function videoPlayer({ wrapper }) {
  let $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)

  let settings = {
    controls: '[data-video-controls]',
    video: 'video[data-video]',
    playBtn: '[data-video-play]',
    pauseBtn: '[data-video-pause]',
  }

  const cache = {
    $controls: $wrapper.find(settings.controls),
    $video: $wrapper.find(settings.video),
    $playBtn: $wrapper.find(settings.playBtn),
    $pauseBtn: $wrapper.find(settings.pauseBtn),
  }

  const initEventListeners = function () {
    cache.$playBtn.on('click', playPauseVideo)
    cache.$pauseBtn.on('click', playPauseVideo)

    if (cache.$video.length) {
      cache.$video.each(function (index, video) {
        video.addEventListener('ended', handleVideoEnd, false)
      })
    }
  }

  const handleVideoEnd = function () {
    $wrapper.removeClass('activated')
  }

  const playPauseVideo = function (e) {
    cache.$video.each(function (index, video) {
      if (!video) return

      if (video.paused) {
        video.play()
        $wrapper.addClass('activated')
      } else {
        video.pause()
        $wrapper.removeClass('activated')
      }
    })
  }

  initEventListeners()
}


/***/ })

}]);